import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from "react-router-dom";
import { Helmet } from 'react-helmet-async';
import { Box, Card, Tabs, Tab, Divider, Stack, IconButton, Alert } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useModuleNavigate } from "../../layouts/main/ModuleNavigation";
import { useSchemeStore } from './schemeStore';
import LoadingProgressBar from '../../components/loading-progressbar/loadingprogressbar';
import EditHeaderDef from '../SchemeDefination/SchemeDefinationPages/EditHeaderDef';

// Import tab components
import SchemeDefinition from './SchemeTabs/SchemeDefinition';
import SchemeSlab from './SchemeTabs/SchemeSlab';
import SchemeArea from './SchemeTabs/SchemeArea';
import SchemeItem from './SchemeTabs/SchemeItem';
import SchemeRetailer from './SchemeTabs/SchemeRetailer';
import SchemeDistributor from './SchemeTabs/SchemeDistributor';
import SchemePoint from './SchemeTabs/SchemePoint';
import SchemeTarget from './SchemeTabs/SchemeTarget';
import SchemeMail from './SchemeTabs/SchemeMail';
import SchemeConditional from './SchemeTabs/SchemeConditional';
import PopUpHandle from '../../commons/PopUpHandle';
import { useAppStore } from '../../store/appStore';


const SchemeDefMaster = () => {
    const { id, pageType } = useParams();
    const navigate = useModuleNavigate();

    const location = useLocation();
    const isCopyScheme = location.state?.data?.copyScheme;


    const [activeTab, setActiveTab] = useState(0);
    const [visitedTabs, setVisitedTabs] = useState([0]);


    const [alertType, setAlertType] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [showAlert, setShowAlert] = useState(false);



    const displayAlert = (type, message, show) => {
        setAlertType(type);
        setAlertMessage(message);
        setShowAlert(show);
    }

    const hideAlert = () => {
        setAlertType('');
        setAlertMessage('');
        setShowAlert(false);
    }



    const [open, setOpen] = useState(false);
    const [errorr, setError] = useState(0);
    const [errorCode, setErrorCode] = useState(null);

    const handleClose = () => {
        setOpen(false);
    };


    const {
        isListChanged,
        setIsListChanged,

    } = useAppStore();


    const {
        error,
        schemeDetails,
        fetchSchemeSetup,
        loading,
        setTabValue,
        schemeData,
        setPrevTabValue,
        setApiResponse,
        apiResponse,
        setDefinitionData,
        setSlabFormData,
        setAreaData,
        setItemData,
        setRetailerData,
        setDistributorData,
        setTargetData,
        setPointData,
        setMailMessageData,
        setConditionalCriteriaData,
        setContributionItemData,
        errorTab,
        definitionData,
        fetchThresholdSettings,
        updateSchemeDetails
    } = useSchemeStore();


    const [displayedSchemeName, setDisplayedSchemeName] = useState('');
    useEffect(() => {

        console.log('schemeDetails', schemeDetails);
        console.log('definitionData', definitionData);


        if (schemeDetails?.SchemeData?.Name) {
            if (isCopyScheme) {
                setDisplayedSchemeName(`${schemeDetails.SchemeData.Name}-Copy`);
            } else if (definitionData && definitionData?.Name) {
                    setDisplayedSchemeName(definitionData.Name);

                } else {

                setDisplayedSchemeName(schemeDetails.SchemeData.Name);
                }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [schemeDetails, isCopyScheme, isListChanged]);

    useEffect(() => {
        console.log("definitionData: ", definitionData);
    }, [definitionData]);


    useEffect(() => {
        if (errorTab) {
            displayAlert('error', errorTab, true);
            setTimeout(() => {
                hideAlert();
            }, 2500);
        }
    }, [errorTab]);
    useEffect(() => {
        if (error) {

             
            setErrorCode(error?.response?.status);
            setError(error?.response?.data?.error?.message);
            setOpen(true);
        }
    }, [error]);
   
    useEffect(() => {
        
        if (isCopyScheme) {
            if (apiResponse && apiResponse?.status === 200) {
                displayAlert('success', apiResponse?.data?.Message || 'Scheme added successfully.', true);
                    setIsListChanged(true);
                setTimeout(() => {
                    hideAlert();
                    setApiResponse(null);

                    
                    navigate(`/scheme/scheme-definition/edit/${apiResponse?.data?.SchemeId}`);

                }, 2500);
            }
        } else if (apiResponse && apiResponse?.status === 200) {
            displayAlert('success', apiResponse?.data?.Message || 'Scheme updated successfully.', true);
            setIsListChanged(true);

            setTimeout(() => {
                hideAlert();
                setApiResponse(null);
            }, 2500);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apiResponse]);


    useEffect(() => {  // NOSONAR
        if (schemeDetails && schemeDetails.SchemeData) {

            if (schemeDetails.SchemeData.SecondarySchemesHigherSlabRepeatationCriteria == null ||

                schemeDetails.SchemeData.SecondarySchemesLowerSlabRepeatationCriteria == null) {

                updateSchemeDetails({

                    SchemeData: {

                        ...schemeDetails.SchemeData,

                        SecondarySchemesHigherSlabRepeatationCriteria: schemeDetails.SecondarySchemesHigherSlabRepeatationCriteria ?? "",

                        SecondarySchemesLowerSlabRepeatationCriteria: schemeDetails.SecondarySchemesLowerSlabRepeatationCriteria ?? "",

                    }

                });

                return;

            }

        }
        setDefinitionData(schemeDetails?.SchemeData || null)
        setSlabFormData(schemeDetails?.Slabs?.length > 0 ? schemeDetails?.Slabs : 'error'  || null)
            setAreaData(schemeDetails?.Area || null)
            setItemData(schemeDetails?.Item || null)
            setRetailerData(schemeDetails?.Retailer || null)
            setDistributorData(schemeDetails?.Distributor || null)
            setTargetData(schemeDetails?.Target || null)
            setPointData(schemeDetails?.Point || null)
        setMailMessageData(schemeDetails?.MailCirculation || null)
        setConditionalCriteriaData(schemeDetails?.ConditionalCriteria || null)
        setContributionItemData(schemeDetails?.ContributionItem || null)
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [schemeDetails]);
    
    useEffect(() => {
        if (id) fetchSchemeSetup(id, isCopyScheme);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        fetchThresholdSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    // Dynamically generate tabs based on schemeData
    const getTabList = () => {
        const tabs = [
            { label: 'Definition', component: <SchemeDefinition /> },
            { label: 'Slab', component: <SchemeSlab /> },
            { label: 'Area', component: <SchemeArea /> },
            { label: 'Item', component: <SchemeItem /> },
            { label: 'Retailer', component: <SchemeRetailer /> },
            { label: 'Distributor', component: <SchemeDistributor /> },
        ];

        if (schemeData?.IsPointBasedScheme) {
            tabs.push({ label: 'Point', component: <SchemePoint /> });
        }

        if (schemeData?.IncludeTarget) {
            tabs.push({ label: 'Target', component: <SchemeTarget /> });
        }

        if (schemeData?.IsSchemeMailCirculation) {
            tabs.push({ label: 'Mail Message', component: <SchemeMail /> });
        }

        if (schemeData?.IsConditionalScheme) {
            tabs.push({ label: 'Conditional Criteria', component: <SchemeConditional /> });
        }

        return tabs;
    };

    const tabList = getTabList();

    const handleTabChange = (_, newValue) => {
        // Get previous tab index and details
        const prevTabIndex = activeTab;
        const prevTab = tabList[prevTabIndex];

        // Set previous tab value with name and value (index)
        setPrevTabValue({
            name: prevTab.label,
            value: prevTabIndex,
        });



        setActiveTab(newValue);
        setTabValue(newValue);
        if (!visitedTabs.includes(newValue)) {
            setVisitedTabs((prev) => [...prev, newValue]);
        }
    };


    return (
        <Card sx={{ margin: '5px 2px', padding: '10px', height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Helmet>
                <title>Scheme Definition | Proclaimz</title>
            </Helmet>

            <EditHeaderDef pageType={pageType} scName={displayedSchemeName || 'Scheme Definition'} />

            <Tabs value={activeTab} onChange={handleTabChange} variant="scrollable" scrollButtons="auto">
                {tabList.map((tab, idx) => (
                    <Tab key={idx} label={tab.label} /> // NOSONAR
                ))}
            </Tabs>
            <Divider />

            <Box sx={{ flexGrow: 1, overflow: 'auto', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                {tabList.map((tab, idx) =>
                    visitedTabs.includes(idx) ? (
                        <Box
                            key={idx} // NOSONAR
                            sx={{
                                display: activeTab === idx ? 'block' : 'none',
                                height: '100%',
                                overflow: 'auto',
                                flexGrow: 1,
                            }}
                        >
                            {tab.component}
                        </Box>
                    ) : null
                )}
            </Box>
            {showAlert && (
                <Stack sx={{ height: '2em', width: '30%', position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -40%)" }} spacing={2}>
                    <Alert
                        severity={alertType}
                        action={
                            <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                    setAlertType('');
                                    setAlertMessage('');
                                    setShowAlert(false);
                                }}
                            >
                                <CloseIcon fontSize="inherit" />
                            </IconButton>
                        }
                    >
                        {alertMessage}
                    </Alert>
                </Stack>
            )}
            {
                open && (
                    <PopUpHandle open={open} handleClose={handleClose} error={errorr} errorCode={errorCode} />
                )
            }
            {loading && <LoadingProgressBar />}
        </Card>
    );
};


export default SchemeDefMaster;
